var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"list"},_vm._l((_vm.systemList),function(subSystemList){return _c('NavGroup',{key:subSystemList.title,attrs:{"group":subSystemList}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }